<button (click)="onClick()" [disabled]="disabled"
  class="px-4 py-4 text-sm font-medium min-w-fit h-12 text-center justify-center rounded-full transition-colors inline-flex items-center gap-1 whitespace-nowrap"
  [ngClass]="[
    themeClass,
    disabled ? 'disabledTheme' : '',
    iconPosition === 'left' ? 'flex-row-reverse' : '',
    width === 'full' ? 'w-full' : ''
  ]">
  {{ text }}
  <span *ngIf="icon" class="material-symbols-rounded text-base">{{ icon }}</span>
</button>